import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { Table }                  from '../table/types/table';
import { UKPostcodeAddressModel } from './typings/uk-postcode.address';

@Component({
  selector   : 'wor-uk-postcode-addresses',
  template: require('./uk-postcode.addresses.component.html')
})
export class UKPostcodeAddressesComponent {
  @Input() addresses: Array<UKPostcodeAddressModel>;

  selectedAddress: UKPostcodeAddressModel;

  tableSettings: Table = {
    columns: [
      {
        classes: 'text-left',
        field  : 'summary',
        header : {
          text: this.translateService.instant('JS_SPACE.COLUMNS.ADDRESS')
        }
      }
    ],
    empty: {
      text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_ADDRESSES_FOUND')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  constructor (
    public  activeModal     : NgbActiveModal,
    private translateService: TranslateService,
  ) {}

  onRowClick ( address : UKPostcodeAddressModel ) : void {
    this.selectedAddress = address.selected
      ? address
      : null;
  }

  onRowDoubleClick ( address : UKPostcodeAddressModel ) : void {
    this.selectedAddress = address;

    this.select();
  }

  select () : void {
    this.activeModal.close(this.selectedAddress.detail);
  }
}
